module.exports = __webpack_public_path__ + "img/placeholder.560c9bf9.png";